import axios from "../axios";

class HomeService {
    getStat() {
        return axios.get(`home/stat`);
    }
}

export default new HomeService();
